import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteDepartment($id: ID!) {
  deleteDepartment(id: $id){
    id
  }
}`;

function deleteDepartment(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteDepartment);
}

export default deleteDepartment;
